/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    title: 'Atividade',
    icon: 'fas fa-cog',
    path: '/atividade',
    view: 'Atividade',
    dir: 'views/app/',
    menu: true,
    meta: {
      role: ['Nenhum'],
      requiresAuth: true,
      allRolesRequired: false
    }
  }, 
  {
    path: '/',
    view: 'Login',
    dir: 'views/app/',
    title: 'Login',
    menu: false,
    meta: {
      role: ['Nenhum'],
      allRolesRequired: true,
      anonymousAuth: true
    }
  },
]
